<template>
  <el-select
    v-if="customer"
    ref="sender"
    filterable
    v-model="selected"
    clearable
    placeholder="Selecione  uma opção"
    @change="update()"
    @clear="clear()"
  >
    <el-option
      v-for="row of senders"
      :key="row.id"
      :label="row.name"
      :value="row.id"
    ></el-option>
  </el-select>
  <span v-else>Nenhum cliente selecionado</span>
</template>

<script>
import { SendersService } from "@/services/senders/senders.services";
export default {
  name: "SenderList",
  props: ["customer"],
  data: function () {
    return {
      senders: [],
      selected: "",
    };
  },
  watch: {
    customer: function (v) {
      const vm = this;
      console.log('watch sender', v, vm.customer)
      vm.fetchSenders();
    },
  },
  methods: {
    clear() {
      const vm = this;
      vm.$emit("clear");
    },
    fetchSenders() {
      const vm = this;
      if (!vm.$props.customer) {
        return false;
      }
      SendersService.listByCustomer(vm.$props.customer)
        .then((response) => {
          vm.senders = response.records;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchSenders();
  },
};
</script>